import { memo, useCallback } from "react";

import type { ForNodeType } from "@/components/features/_model/types";

import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import { FormFieldLayout } from "../../layouts";

type Props = {
	discountName: ForNodeType<string>;
	onChangeName: (value: string) => void;
};

export const DiscountNameFormFieldComposition = memo(({ discountName, onChangeName }: Props) => {
	/**
	 * ディスカウント名の変更
	 */
	const handleChangeDiscountName = useCallback(
		(value: string) => {
			onChangeName(value);
		},
		[onChangeName],
	);

	return (
		<FormFieldLayout title="ディスカウントの名前">
			<div className="space-y-2">
				<InputTextField
					value={discountName.value}
					errorMessage={discountName.error}
					handleChange={handleChangeDiscountName}
				/>

				<p className="whitespace-pre-wrap text-sm text-caption-50">
					ディスカウントの内容が伝わるシンプルな名前にしましょう。
				</p>
			</div>
		</FormFieldLayout>
	);
});
